export const firstSection = (title, lang)  => `
<section>
  <h1 id="fs-title">${title}</h1>
  <p>
    Inspired by
    <strong class="c-yellow"> Learning How to Learn</strong>, a
    <span class="c-violet">Coursera</span>
    course taught by <span class="c-red">Dr. Barbara Oakley</span> and
    <span class="c-orange">Dr. Terrence Sejnowski</span>, Offered By
    <span class="c-cyan">McMaster University</span> and
    <span class="c-green">University of California San Diego</span>
  </p>
  <p id="fs-lang">${lang}</p>
</section>
`;
